<template>
  <ion-label slot="end" v-if="location && location.length > 0">
    <ion-img :src="src" @ionError="brokeImage"></ion-img>
  </ion-label>
</template>

<script>
export default {
  name: "label-location",
  components: {},
  props: ["location"],
  data() {
    return {
      key: process.env.VUE_APP_GOOGLE_API_KEY
    };
  },
  computed: {
    src() {
      let params = {
        zoom: 15,
        size: "350x200",
        maptype: "roadmap",
        center: this.location,
        markers: `color:red|${this.location}`,
        key: this.key
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + encodeURIComponent(params[key]))
        .join("&");
      return `https://maps.googleapis.com/maps/api/staticmap?${query}`;
    },
    broken() {
      return require("../assets/broken.png");
    }
  },
  created() {
    this.image = this.src;
  },
  methods: {
    brokeImage() {
      this.image = this.broken;
    }
  }
};
</script>

<style scoped>
ion-img {
  width: 300px;
  max-width: 100%;
  margin-left: 0;
  margin-right: auto;
  margin-bottom: 15px;
}
</style>